// /home/szymon/kreator2/frontend/src/utils/getSvgDimensions.js
// v1.0.0 – Funkcja do pobierania szerokości i wysokości z pliku SVG (URL).

/**
 * Asynchronicznie pobiera plik SVG z podanego URL
 * i zwraca obiekt { width, height } odczytany z atrybutów
 * <svg width="..." height="..."> lub z viewBox="0 0 w h".
 * W razie błędu zwraca { width: 200, height: 200 }.
 * @param {string} svgUrl - URL do pliku SVG (jeśli svgStringContent nie jest podany).
 * @param {string} [svgStringContent] - Opcjonalna zawartość SVG jako string. Jeśli podana, svgUrl jest ignorowany.
 */
export default async function getSvgDimensions(svgUrl, svgStringContent = null) {
    try {
      let svgText;
      if (svgStringContent) {
        svgText = svgStringContent;
      } else {
        const resp = await fetch(svgUrl);
        if (!resp.ok) {
          throw new Error(`Błąd pobierania SVG, status=${resp.status}`);
        }
        svgText = await resp.text();
      }
      
      const parser = new DOMParser();
      const doc = parser.parseFromString(svgText, 'image/svg+xml');
      const svgEl = doc.documentElement;
      if (!svgEl || svgEl.nodeName === 'parsererror') {
        console.warn('[getSvgDimensions] SVG parsing error. Content:', svgText.substring(0, 500));
        throw new Error('Błąd parsowania SVG');
      }
  
      let wAttr = svgEl.getAttribute('width');
      let hAttr = svgEl.getAttribute('height');
      let wNum = wAttr ? parseFloat(wAttr.replace('px', '')) : 0;
      let hNum = hAttr ? parseFloat(hAttr.replace('px', '')) : 0;
  
      if (wNum && hNum) {
        return { width: wNum, height: hNum };
      }
      const vb = svgEl.getAttribute('viewBox');
      if (vb) {
        const parts = vb.split(/\s+/).map(Number);
        if (parts.length === 4 && !isNaN(parts[2]) && !isNaN(parts[3])) {
          return { width: parts[2], height: parts[3] };
        }
      }
      // Zwiększamy domyślne wymiary w razie braku danych w SVG
      console.warn('[getSvgDimensions] Could not find width/height or viewBox, returning default 800x800');
      return { width: 800, height: 800 };
    } catch (err) {
      console.warn('[getSvgDimensions] Fetch or parse error, returning default 800x800 =>', err);
      // Zwiększamy domyślne wymiary w razie błędu
      return { width: 800, height: 800 };
    }
  }
